export default __webpack_public_path__ + "static/media/Clinic_Dir_Bio_Joey_Jove_Olympia_040620.9fe32f3f.pdf";